
import React from 'react';
import { connect } from 'react-redux';
import GradientCards from '../../../../../_components/common/GradientCards'

import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import {
    Card, CardImg, CardText, CardBody,
    CardTitle,
} from 'reactstrap';
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import CircularButtonGroup from '../../../../../_components/common/CircularButtonGroup'
import RoutableSelects from '../../../../../_components/common/RoutableSelects'
import DynamicGradientTables from '../../../../../_components/common/DynamicGradientTables'
import { buttonGroupData } from './SwotButtonGroupData'
import { swot_category_data_1 } from './SwotCatagoryData'
import dataFormater from '../../dataFormater'
import buttonDataFormater from '../../buttonDataFormater'
import {global_data} from '../../globalData'
import { AnalyzeAction } from '../../../../../_actions/Analyze/analyze.action'
import './index.css'
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';


import SwotIcon from '../../../../../images/swotIcon.png';



//overlay
import OverLayLoader from '../../overLayLoader';



class SWOT extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            teamName: '',
            teamId: '',
            getPaUserPermissionListResponse: '',
            navData: [],
            class_name: {
                main_container: 'd-flex flex-row flex-wrap align-items-start col-12',
                container: {
                    container: "d-flex flex-column col-sm-6 col-md-6 col-lg-6 w-100 px-2 py-1",
                    style: {
                        margin: 1,
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 my-1',
                    style: {
                        paddingLeft: 60,
                        margin: 1
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-row align-items-center justify-content-start text-white ',
                    header_container_non_routable_title: 'font-class-compatibility-title font-weight-bold py-1',
                    header_container_non_routable_optional: 'font-class-compatibility-optional p-1',
                },
                child_container: {
                    child_container: "d-flex flex-column col-12 flex-wrap w-100 px-0",
                    style: {
                        margin: 1
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex col-sm-12 col-md-12 col-lg-12 p-2 mb-1 text-dark text-center',
                    child_content_container_header: 'font-weight-bold py-1 px-3 font-class-compatibility-title',
                    child_content_container_desc: 'font-weight-bold font-italic',
                    child_content_container_footer: '',
                }
            },
            class_nam2: {
                main_container: 'd-flex flex-row flex-wrap align-items-stretch col-12',
                container: {
                    container: "d-flex flex-column col-sm-6 col-md-3 col-lg-3 w-100 px-1 py-1",
                    style: {
                        margin: 1,
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 my-1',
                    style: {
                        paddingLeft: 60,
                        margin: 1
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-row align-items-center justify-content-start text-white ',
                    header_container_non_routable_title: 'font-class-compatibility-title font-weight-bold py-1',
                    header_container_non_routable_optional: 'font-class-compatibility-optional p-1',
                },
                child_container: {
                    child_container: "d-flex flex-column col-12 flex-wrap w-100 px-0 flex1_0",
                    style: {
                        margin: 1
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex flex-column pt-2 pb-5 px-2 mb-1 text-dark text-left flex1',
                    child_content_container_header: 'font-weight-bold py-1 font-class-compatibility-title',
                    child_content_container_desc: 'py-3 small',
                    child_content_container_footer: '',
                }
            },
            filterData: null,
            swot_category_data_0: [],
            swot_all_orientation: [],
            buttonGroupData: [{
                img: SwotIcon,
                link: `/organisation/${this.props.match.params.id}/user/swot/0`,
                name: "All",
                id: 0,
                tooltip_id:0
            }]
        }
    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    componentDidUpdate(prevProp) {
        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
                })
            }
        }
        if(prevProp.AnalyzeDataResonse != this.props.AnalyzeDataResonse) {
            if(this.props.AnalyzeDataResonse !== '') {
                this.setState({
                    swot_category_data_0:[],
                    buttonGroupData: [{
                        img: SwotIcon,
                        link: `/organisation/${this.props.match.params.id}/user/swot/0`,
                        name: "All",
                        id: 0,
                        tooltip_id:0
                    }]
                },() => {
                    this.setState({
                        swot_category_data_0: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_all"),
                        swot_all_orientation: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_each_orientation"),
                        buttonGroupData: [this.state.buttonGroupData[0]].concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_each_orientation"),'swot_orientation'))
                    },() => {
                    })
                })
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        const { id, swotid } = this.props.match.params
        if(swotid === undefined) {
            this.props.history.push(this.props.match.url + '/0')
        }
        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse !== '') {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'SWOT') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }
        //filter data
        if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
            })
        }

        //Analyze data
        if(this.props.AnalyzeDataResonse !== '') {
            this.setState({
                swot_category_data_0: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_all"),
                swot_all_orientation: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_each_orientation"),
                buttonGroupData: this.state.buttonGroupData.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_each_orientation"),'swot_orientation'))
            },() => {
            })
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    onClickSelect = (link) => {
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    renderOrientationBased(swotId) {
        var result = this.state.swot_all_orientation.map((obj,key) => {
            if(obj.id == swotId) {
                return (
                    <div key={key} className="gradient-flex" style={{paddingLeft:0,paddingRight:0}}>
                        <DynamicGradientTables classNameProps={this.state.class_nam2} data={obj.data}/>
                        <CircularButtonGroup buttonGroupData={this.state.buttonGroupData} swotCatagory={this.props.match.params.swotid} singleButton={false} /> 
                    </div>
                )
            }
        })
        return result 
    }

    render() {
        const { data, navData } = this.state

        const { assessorGroupsResponse, saveAssesorGroupListResponse } = this.props;
        return (
            <div>
                <Navbar navItems={navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                        callBack={this.doSomthing.bind(this)}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <OverLayLoader>
                        <div className="analyz-container">

                            <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                            {
                                this.props.singleValidatorResponse ?
                                    <p className="m-3 text-center">
                                        Team Members should be more than 2
                                    </p>:
                                    <React.Fragment>
                                        {this.props.AnalyzeDataResonse == '' ?
                                            !this.props.getAnalyzeError ?
                                            // <p className="text-center">
                                            //     <i className="fas fa-spinner fa-spin " ></i>
                                            //     &nbsp;loading
                                            // </p> 
                                                this.props.teamAvailabilityBoolean ?
                                                    <p className="text-center mt-4">
                                                        <i className="fas fa-spinner fa-spin " ></i>
                                                        &nbsp;loading
                                                    </p>
                                                :
                                                    <p className="text-center mt-4">
                                                        &nbsp;{this.props.teamAvailabilityText}
                                                    </p>
                                            :
                                            <p className="text-center my-5">{this.props.getAnalyzeError.message}</p>
                                            :
                                            <div className="swot-container-sub">
                                                {
                                                    this.props.match.params.swotid == 0 ?
                                                        <div className="d-flex justify-content-center drop-down-container my-3">
                                                            <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">Choose Orientation:</h6>
                                                            <RoutableSelects swotid={this.props.match.params.swotid} buttonGroupData={this.state.buttonGroupData} {...this.props} />
                                                        </div> :
                                                        <div className="mt-4">
                                                            <h5 className="font-weight-bold font-italic">{this.state.buttonGroupData[this.props.match.params.swotid] !== undefined && this.state.buttonGroupData[this.props.match.params.swotid].name} Orientation</h5>
                                                            {/* <CircularButtonGroup buttonGroupData={this.state.buttonGroupData} swotCatagory={this.props.match.params.swotid} singleButton={true} /> */}
                                                        </div>
                                                }
                                                {
                                                    this.props.match.params.swotid == 0 ?
                                                    <div className="gradient-flex" style={{paddingLeft:30,paddingRight:30}}>
                                                    {
                                                        this.state.swot_category_data_0.length != 0 ?
                                                        <React.Fragment>
                                                            <DynamicGradientTables classNameProps={this.state.class_name} data={this.state.swot_category_data_0}/>
                                                            <CircularButtonGroup buttonGroupData={this.state.buttonGroupData} swotCatagory={this.props.match.params.swotid} singleButton={false} toolTip={false} /> 
                                                        </React.Fragment>:
                                                        null
                                                    }
                                                    </div>:
                                                    this.renderOrientationBased(this.props.match.params.swotid)
                                                }
                                            </div>
                                            }
                                </React.Fragment>
                            }
                        </div>
                    </OverLayLoader>
                </ div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    //Analyze
    const { getAnalyzeLoading } = state.getAnalyzeData
    const getAnalyzeError = state.getAnalyzeData.error
    const AnalyzeDataResonse = (!getAnalyzeLoading && !getAnalyzeError) ?  state.getAnalyzeData.data : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;
    const singleValidatorResponse = state.singleValidatorReducer.data;
    
    const teamAvailabilityText = state.teamAvailabilityReducer.data;
    const teamAvailabilityBoolean = state.teamAvailabilityReducer.availibility;

    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        AnalyzeDataResonse,
        getAnalyzeLoading,
        getAnalyzeError,
        singleValidatorResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,

        teamAvailabilityText,
        teamAvailabilityBoolean,
    }
}

export default connect(mapStateToProps)(SWOT)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/SWOT/index.js